// extracted by mini-css-extract-plugin
module.exports = {"Link":"link_Link__MbW2Z"};